<template>
  <component :is="tag"
             class="dropdown"
             :class="{show:isOpen}"
             @click="toggleDropDown"
             v-click-outside="closeDropDown">
    <a class="dropdown-toggle btn-rotate"
       :class="titleClasses"
       data-toggle="dropdown">
      <slot name="title">
        <i v-if="alignmentIcon === 'right' " :class="icon"/>
        <div class="notification d-inline-block">
          {{title}}
          <b class="caret"/>
        </div>
        <i v-if="alignmentIcon === 'left' " :class="icon"/>
      </slot>
    </a>
    <ul class="dropdown-menu text-right" :class="{show:isOpen}">
      <slot/>
    </ul>
  </component>
</template>
<script>
  export default {
    props: {
      tag: {
        type: String,
        default: "li"
      },
      alignmentIcon: {
        type: String,
        default: "left"
      },

      title: String,
      icon: String,
      titleClasses: [String, Object, Array]
    },
    data() {
      return {
        isOpen: false
      };
    },
    methods: {
      toggleDropDown() {
        this.isOpen = !this.isOpen;
        this.$emit("change", this.isOpen);
      },
      closeDropDown() {
        this.isOpen = false;
        this.$emit('change', false);
      }
    }
  };
</script>
